import { NgModule } from '@angular/core';
import { IfHasRoleDirective } from './if-has-role/if-has-role.directive';

@NgModule({
	imports: [],
	declarations: [IfHasRoleDirective],
	exports: [IfHasRoleDirective]
})
export class DirectivesModule {}
